import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CmsPostQueryCriteriaClass extends BaseCriteriaModel {
  // Hdr
  post_category?: Optional<string> = Optional.empty();

  // Ext
  hdr_guid?: Optional<string> = Optional.empty();
}

export class CmsPostCriteriaModelQuery {
  query = '';

  constructor(cmsPostCriteriaModel: CmsPostQueryCriteriaClass) {

    if (!cmsPostCriteriaModel) {
      return;
    }

    this.query += cmsPostCriteriaModel.post_category.filter(x => x !== '').map(x => '&post_category=' + x).orElse('');
    this.query += cmsPostCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + cmsPostCriteriaModel.status;
    this.query += '&orderBy=' + cmsPostCriteriaModel.orderBy;
    this.query += '&order=' + cmsPostCriteriaModel.order;
    this.query += '&offset=' + cmsPostCriteriaModel.offset + '&limit=' + cmsPostCriteriaModel.limit;
  }
}
